
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e93743a4&scoped=true!postcss!sass!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Announcement.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Announcement.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-e93743a4!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Announcement.vue"),
  /* scopeId */
  "data-v-e93743a4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/components/Announcement.vue
// module id = 1096
// module chunks = 0